// extracted by mini-css-extract-plugin
export default {"container":"Contact_container__o+8Lk","content":"Contact_content__A4CK6","linecontainer":"Contact_linecontainer__5elTZ","line1":"Contact_line1__YchNH","line2":"Contact_line2__vnMG1"};